// extracted by mini-css-extract-plugin
export default {"main":"Lubricants_main__Bu8s9","columnedBlock":"Lubricants_columnedBlock__v+-JE"};